import { Injectable } from '@angular/core';
import { Transport } from '../models/transport.model';
import { TransportItem } from '../models/transport-item.model';
import dayjs from 'dayjs';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { TransportExtendedService } from './transport-extended.service';
import { ItemConditionEnum } from '../models/enums/item-condition.enum';
import { QuotationStatusEnum } from '../models/enums/quotation-status.enum';
import { Civility } from '../models/enums/civility.enum';
import { HandlingTypeEnum } from '../models/enums/handling-type.enum';
import { TransportTypology } from '../models/enums/transport-typology.enum';
import { AccessConstraintEnum } from '../models/enums/access-constraint.enum';
import { LoadingConstraintEnum } from '../models/enums/loading-constraint.enum';
import { InsuranceItem } from '../models/insurance-item.model';

@Injectable({
  providedIn: 'root',
})
export class ConsoleService {
  constructor(private transportService: TransportExtendedService) {}

  fakeTransport(): Observable<Transport> {
    return this.transportService.createEmpty().pipe(
      map(transport => {
        transport.itemsNature = 'Electro-ménager emballé';
        transport.quotationStatus = QuotationStatusEnum.NONE;
        transport.itemsCondition = ItemConditionEnum.NEW;
        transport.creationDate = dayjs();

        // assurance
        transport.insuranceItem = new InsuranceItem({
          itemsNature: transport.itemsNature,
          pricingRate: 0.09,
          maxValue: 200000,
        });
        transport.goodsValue = 150;

        transport.pickupDate = ConsoleService.addBusinessDays(dayjs(), 4);
        transport.pickupAddressFullname = 'Entreprise Pickup';
        transport.pickupAddressStreetNumber = 'Hangar G2';
        transport.pickupAddressStreet = 'QUAI ARMAND LALANDE';
        transport.pickupAddressZipCode = '33300';
        transport.pickupAddressCity = 'BORDEAUX';
        transport.pickupAddressCountry = 'FR';
        transport.pickupAddressAdditionals = '';
        transport.pickupContactCivility = Civility.MALE;
        transport.pickupContactFirstName = 'Martin';
        transport.pickupContactLastName = 'Martinez';
        transport.pickupContactMail = 'bary-user@yopmail.com';
        transport.pickupContactPhone = '0555555555';
        transport.pickupAccessConstraint = AccessConstraintEnum.NONE;
        transport.pickupLoadingConstraint = LoadingConstraintEnum.HAYON;
        transport.pickupTimeslotStart = 10;
        transport.pickupTimeslotEnd = 15;
        transport.pickupRegisteredAddressId = undefined;

        transport.deliveryDate = ConsoleService.addBusinessDays(dayjs(), 20);
        transport.deliveryAddressFullname = 'Entreprise Delivery';
        transport.deliveryAddressStreetNumber = '1';
        transport.deliveryAddressStreet = 'Place de la porte de versaille';
        transport.deliveryAddressZipCode = '75015';
        transport.deliveryAddressCity = 'Paris';
        transport.deliveryAddressCountry = 'FR';
        transport.deliveryAddressAdditionals = '';
        transport.deliveryContactCivility = Civility.FEMALE;
        transport.deliveryContactFirstName = 'Joseline';
        transport.deliveryContactLastName = 'Bachelle';
        transport.deliveryContactMail = 'bary-user@yopmail.com';
        transport.deliveryContactPhone = '0555555555';
        transport.deliveryAccessConstraint = AccessConstraintEnum.NONE;
        transport.deliveryLoadingConstraint = LoadingConstraintEnum.NONE;
        transport.deliveryTimeslotStart = 10;
        transport.deliveryTimeslotEnd = 15;
        transport.deliveryRegisteredAddressId = undefined;

        transport.items = [];
        const transportItem = new TransportItem();
        transportItem.handlingType = HandlingTypeEnum.PALLET;
        transportItem.length = 120;
        transportItem.width = 80;
        transportItem.maxHeight = 150;
        transportItem.weight = 150;
        transportItem.quantity = 1;
        transportItem.groundPalletQuantity = 1;

        transport.offerId = 1;

        transport.items.push(transportItem);

        return transport;
      })
    );
  }

  private static addBusinessDays(originalDate: dayjs.Dayjs, numDaysToAdd: number): dayjs.Dayjs {
    const Sunday = 0;
    const Saturday = 6;
    let daysRemaining: any = numDaysToAdd;

    let newDate = originalDate.clone();

    while (daysRemaining > 0) {
      newDate = newDate.add(1, 'day');
      if (newDate.day() !== Sunday && newDate.day() !== Saturday) {
        daysRemaining--;
      }
    }
    return newDate;
  }

  public getGeneralTransport(): Transport {
    return new Transport({
      pickupAddressFullname: 'Aéroport de Bordeaux',
      pickupAddressStreet: 'Aéroport de Bordeaux',
      pickupAddressZipCode: '33700',
      pickupAddressCity: 'Mérignac',
      pickupAddressCountry: 'FR',
      pickupAddressAdditionals: '',
      pickupTimeslotStart: 10,
      pickupTimeslotEnd: 17,
      pickupAddressGpsCoords: '44.82968,-0.7129038999999999',
      pickupContactCivility: Civility.MALE,
      pickupContactFirstName: '',
      pickupContactLastName: '',
      pickupContactMail: '',
      pickupContactPhone: '',
      pickupDate: ConsoleService.addBusinessDays(dayjs(), 4),
      pickupLoadingConstraint: 'dock',
      pickupAccessConstraint: AccessConstraintEnum.NONE,
      deliveryAddressFullname: 'Aéroport de Paris-Orly',
      deliveryAddressStreet: 'Aéroport de Paris-Orly',
      deliveryAddressZipCode: '94390',
      deliveryAddressCity: 'Orly',
      deliveryAddressCountry: 'FR',
      deliveryAddressAdditionals: '',
      deliveryTimeslotStart: 10,
      deliveryTimeslotEnd: 17,
      deliveryAddressGpsCoords: '48.7272255,2.3623199',
      deliveryContactCivility: Civility.MALE,
      deliveryContactFirstName: '',
      deliveryContactLastName: '',
      deliveryContactMail: '',
      deliveryContactPhone: '',
      deliveryDate: ConsoleService.addBusinessDays(dayjs(), 20),
      deliveryLoadingConstraint: LoadingConstraintEnum.DOCK,
      deliveryAccessConstraint: AccessConstraintEnum.NONE,
      pickupAddressInseeCode: '33281',
      deliveryAddressInseeCode: '91479',
      itemsCondition: ItemConditionEnum.NEW,

      transportTypology: TransportTypology.GENERAL_GOODS,
      items: [
        {
          handlingType: HandlingTypeEnum.PALLET,
          maxHeight: 110,
          length: 120,
          quantity: 1,
          weight: 40,
          width: 60,
          groundPalletQuantity: null,
          otherSpecificQuantity: null,
        },
      ],
      transportExtraConditions: [],
      transporter: {
        id: 1,
      },
      insuranceItem: undefined,
    });
  }

  public getAdrTransport(): Transport {
    return new Transport({
      pickupAddressFullname: 'Aéroport de Bordeaux',
      pickupAddressStreet: 'Aéroport de Bordeaux',
      pickupAddressZipCode: '33700',
      pickupAddressCity: 'Mérignac',
      pickupAddressCountry: 'FR',
      pickupAddressAdditionals: '',
      pickupTimeslotStart: 10,
      pickupTimeslotEnd: 17,
      pickupAddressGpsCoords: '44.82968,-0.7129038999999999',
      pickupContactCivility: Civility.MALE,
      pickupContactFirstName: '',
      pickupContactLastName: '',
      pickupContactMail: '',
      pickupContactPhone: '',
      pickupReference: null,
      pickupDate: ConsoleService.addBusinessDays(dayjs(), 4),
      pickupLoadingConstraint: LoadingConstraintEnum.DOCK,
      pickupAccessConstraint: AccessConstraintEnum.NONE,
      deliveryAddressFullname: 'Aéroport de Paris-Orly',
      deliveryAddressStreet: 'Aéroport de Paris-Orly',
      deliveryAddressZipCode: '94390',
      deliveryAddressCity: 'Orly',
      deliveryAddressCountry: 'FR',
      deliveryAddressAdditionals: '',
      deliveryTimeslotStart: 10,
      deliveryTimeslotEnd: 17,
      deliveryAddressGpsCoords: '48.7272255,2.3623199',
      deliveryContactCivility: Civility.MALE,
      deliveryContactFirstName: '',
      deliveryContactLastName: '',
      deliveryContactMail: '',
      deliveryContactPhone: '',
      deliveryDate: ConsoleService.addBusinessDays(dayjs(), 20),
      deliveryLoadingConstraint: LoadingConstraintEnum.DOCK,
      deliveryAccessConstraint: AccessConstraintEnum.NONE,
      pickupAddressInseeCode: '33281',
      deliveryAddressInseeCode: '91479',
      itemsCondition: ItemConditionEnum.NEW,
      pickupPhoneCall: null,
      deliveryPhoneCall: null,
      offerId: null,
      items: [
        {
          handlingType: HandlingTypeEnum.PALLET,
          maxHeight: 110,
          length: 120,
          quantity: 1,
          weight: 40,
          width: 60,
          groundPalletQuantity: null,
          otherSpecificQuantity: null,
        },
      ],
      transportExtraConditions: [
        {
          adrIsLimitedQuantity: false,
          adrCodeUN: '12',
          adrDescription: 'CARTOUCHES À PROJECTILE INERTE POUR ARMES',
          adrPacking: 'fût',
          adrPackingNumber: 1,
          adrPackingGroup: null,
          adrTransportCategory: null,
          adrNetWeight: 7,
          adrIsDangerousForEnvironment: null,
          adrIsWaste: null,
          controlledTemperature: null,
        },
        {
          adrIsLimitedQuantity: true,
          adrNetWeight: 8,
          controlledTemperature: null,
        },
      ],
      transporter: {
        id: 1,
      },
    });
  }
}
